<div :class="$store?.state?.appMode">
  <div v-if="$store?.state?.processLoad && $route.name != 'login-view'" class="row loading-view">
    <c-loading :loading="true"></c-loading>
  </div>
  <div v-else-if="serverError" class="row loading-view">{{ $t("errorServerError") }}</div>
  <div v-else class="row router-view">
    <div v-if="!$helper?.accessToken?.value" class="row">
      <router-view />
    </div>
    <div v-else class="row">
      <div v-if="!$store?.state?.menus && !$store?.state?.menus.length" class="row">
        <c-loading :loading="true"></c-loading>
      </div>
      <div v-else class="row">
        <c-sidebar v-if="$store?.state?.menus && $store?.state?.menus.length"></c-sidebar>
        <div
          v-if="$store?.state?.menus && $store?.state?.menus.length"
          :class="$helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'fix-content':'fix-content-min'"
          class="container-view"
        >
          <div class="row wrapper-view">
            <nav>
              <c-navbar></c-navbar>
            </nav>
            <div :class="$route.name === 'viewStock' ? `container-scroll-active` : ``" class="container-scroll">
              <router-view class="row animate-bottom"></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="row">
    <search-map v-if="$store?.state?.isSearchMap?.modal"></search-map>
  </div> -->

  <div class="outside-div"></div>
</div>
